export default "__VITE_ASSET__c32fc506__"